import type { Metadata } from 'next';

const LCV_METATAG = {
  title: 'อีซูซุประเทศไทย Isuzu Thailand Official',
  description:
    'ดูข้อมูลรถอีซูซุ D-Max และ MU-X คำนวณค่างวด เปรียบเทียบรุ่นรถ ขอสินเชื่อ ดูข้อเสนอพิเศษต่างๆ พร้อมทั้งดาวน์โหลดโบรชัวร์ และค้นหาศูนย์บริการใกล้บ้านท่าน',
  url: 'https://www.isuzu-tis.com/',
  image:
    'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltb8ebe5359f8c9db3/62fb311dea0d864c464abcaf/OG_ISUZU.jpg',
} as const;

export const LCV_METADATA: Metadata = {
  title: LCV_METATAG.title,
  description: LCV_METATAG.description,
  openGraph: {
    title: LCV_METATAG.title,
    description: LCV_METATAG.description,
    url: LCV_METATAG.url,
    images: [
      {
        url: LCV_METATAG.image,
        width: 1200,
        height: 630,
      },
    ],
  },
  alternates: {
    canonical: LCV_METATAG.url,
  },
};
